'use client'

import { useRouter } from 'next/navigation'

import e_application_SA_CA_FCCA from '@/assets/images/e_application_SA_CA_FCCA.svg'
import { LinkButton } from '@/components/buttons'
import Link from '@/components/Link'

const pds_CM_SA = '/pdfs/PDS CM SA-i_v3_1123 [clean].pdf'
const pds_CM_CA = '/pdfs/PRODUCT DISCLOSURE SHEET (PDS) - Commodity Murabahah Current Account-i.pdf'
const pds = '/pdfs/TD-i PDS V2_2019.pdf'

const CM_TD = () => {
  const router = useRouter()
  return (
    <div className="text-grey-color">
      <ul>
        <li>
          <a
            href="https://www.alrajhibank.com.my/assets/compressed/CMTD-NoAcc4.zip"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            Click here
          </a>{' '}
          to download and complete all forms:
        </li>
        <div>1.&emsp;Account Opening & Placement Form</div>
        <div>2.&emsp;Tax Residency Self-Certification Form</div>
      </ul>
      <ul>
        <li>If you are a US Citizen/US Tax Resident/US Indicia, complete as follows:</li>
        <div>3.&emsp;For US Citizen/US Tax Resident, complete FATCA W-9 Form</div>
        <div>4.&emsp;For US Indicia, complete FATCA W-8BEN Form</div>
      </ul>
      <ul>
        <li>Please read and understand the following:</li>
        <div>
          2.&emsp;
          <Link href="/tnc">
            Terms and Conditions for Commodity Murabahah Term Deposit Account-i
          </Link>
        </div>
        <div>
          3.&emsp;
          <a
            href={pds}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            Product Disclosure Sheet Commodity Murabahah Term Deposit Account-i
          </a>
        </div>
      </ul>
      <ul>
        <li>Based on your choice of Savings/Current Account, complete one of the following:</li>
        <div>7.&emsp;For Qard Savings Account-i - Complete Qard Savings Account-i Agreement</div>
        <div>8.&emsp;For Qard Current Account-i - Complete Qard Current Account-i Agreement</div>
        <div>
          9.&emsp;For Commodity Murabahah Current/Savings Account-i, please read and understand the
          following:
        </div>
        <ul>
          <li>
            <Link href="/tnc">
              Terms and Conditions for Commodity Murabahah Savings/Current Account-i
            </Link>
          </li>
          <li>
            <a
              href={pds_CM_SA}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              Product Disclosure Sheet Commodity Murabahah Savings Account-i
            </a>{' '}
            or
          </li>
          <li>
            <a
              href={pds_CM_CA}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              Product Disclosure Sheet Commodity Murabahah Current Account-i
            </a>
          </li>
        </ul>
      </ul>
      <div className="p-2 border rounded background-indigo my-3">
        Note: You are not required to sign-off all the Forms when you submit this application. The
        signing of these Forms will be performed during your visit to the Branch after the account
        is opened.
      </div>
      <ul>
        <li>Scan and attach the following supporting documents with your application:</li>
      </ul>
      <img src={e_application_SA_CA_FCCA.src} width="100%" alt="e_application_SA_CA_FCCA" />
      <div className="my-3 d-flex gap-3">
        <LinkButton
          text="Profit Rate"
          onClick={() => router.push('/personal/deposits/term-deposit-board-profit-rates/')}
        />
        <LinkButton
          text="Product Information"
          onClick={() => router.push('/personal/deposits/term-deposit-i/')}
        />
      </div>
      <ul>
        <li>
          Submit all of the above to{' '}
          <a href="mailto:onlineaccountopening@alrajhibank.com.my">
            onlineaccountopening@alrajhibank.com.my
          </a>
        </li>
      </ul>
      <div className="p-2 border rounded background-indigo my-3">
        Note: You will be notified to visit your selected branch to activate your account during
        banking hours.
      </div>
    </div>
  )
}

export default CM_TD
